// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-config-section {
  padding: 2rem;
  background: #f4f6f8;
  min-height: 100vh;
  color: #334155;
}
.email-config-section .email-config-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}
.settings-card.no-config-card {
  text-align: center;
  padding: 3rem 1.5rem;
}
.settings-card.no-config-card .no-config-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.settings-card.no-config-card .no-config-content .no-config-icon {
  color: #9ca3af;
  margin-bottom: 1rem;
}
.settings-card.no-config-card .no-config-content h4 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
.settings-card.no-config-card .no-config-content p {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 2rem;
  max-width: 400px;
}
.settings-card.no-config-card .no-config-content .create-account-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.settings-card.no-config-card .no-config-content .create-account-btn:hover:not(:disabled) {
  background: #003a7a;
  transform: translateY(-1px);
}
.settings-card.no-config-card .no-config-content .create-account-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.2);
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.form-group-email-config {
  margin-bottom: 1rem;
}
.form-group-email-config label {
  display: block;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}
.form-group-email-config input, .form-group-email-config textarea, .form-group-email-config select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
  transition: all 0.3s ease;
}
.form-group-email-config input:focus, .form-group-email-config textarea:focus, .form-group-email-config select:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.form-group-email-config input::placeholder, .form-group-email-config textarea::placeholder, .form-group-email-config select::placeholder {
  color: #94a3b8;
}
.form-group-email-config select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.form-group-email-config .display-value {
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}
.form-group-email-config .display-value.password-mask {
  font-family: monospace;
  letter-spacing: 2px;
  overflow: hidden;
}
.form-group-email-config .display-value.status {
  font-weight: 600;
  text-align: center;
}
.form-group-email-config .display-value.status.enabled {
  color: #059669;
  background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);
  border-color: rgba(5, 150, 105, 0.2);
}
.form-group-email-config .display-value.status.disabled {
  color: #dc2626;
  background: linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);
  border-color: rgba(220, 38, 38, 0.2);
}
.form-group-email-config .change-password-btn {
  background: #f59e0b;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
}
.form-group-email-config .change-password-btn:hover:not(:disabled) {
  background: #d97706;
  transform: translateY(-1px);
}
.form-group-email-config .change-password-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.smtp-info {
  margin-top: 1rem;
  padding: 1rem;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
}
.smtp-info .info-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  color: #3b82f6;
  font-weight: 500;
  font-size: 0.875rem;
}
.smtp-info .info-content {
  font-size: 0.75rem;
  color: #6b7280;
}
.smtp-info .info-content .info-item {
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
}
.smtp-info .info-content .info-item .label {
  font-weight: 500;
  color: #374151;
}
.smtp-info .info-content .info-item .value {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  font-size: 0.6875rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
}

.modal {
  background: #ffffff;
  border-radius: 12px;
  max-width: 600px;
  width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.modal.email-config-modal {
  max-width: 800px;
}
.modal.password-modal {
  max-width: 500px;
}
.modal .modal-header {
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}
.modal .modal-header h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #004A9A;
  margin: 0;
}
.modal .modal-header .close-btn {
  border: none;
  background: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal .modal-header .close-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.modal .modal-header .close-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.modal .modal-body {
  padding: 1.5rem;
  flex: 1 1;
  overflow-y: auto;
}
.modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.modal .modal-footer .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
}
.modal .modal-footer .cancel-btn:hover {
  background: #e2e8f0;
}
.modal .modal-footer .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.modal .modal-footer .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.modal .modal-footer .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
  opacity: 0.6;
}

.step-info {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}
.step-info svg {
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: #3b82f6;
}
.step-info p {
  margin: 0;
  color: #1e40af;
  font-size: 0.95rem;
  line-height: 1.5;
}
.step-info.success {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.step-info.success svg {
  color: #16a34a;
}
.step-info.success p {
  color: #166534;
}

.password-mismatch-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  margin-top: 1rem;
  color: #dc2626;
  font-size: 0.9rem;
}
.password-mismatch-error svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .email-config-section {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons .cancel-btn,
  .action-buttons .save-btn {
    width: 100%;
    justify-content: center;
  }
  .modal {
    margin: 1rem;
    width: calc(100% - 2rem);
  }
  .settings-card {
    padding: 1rem;
  }
  .step-info {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/EmailConfigSettings/EmailConfigSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAAF;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AADJ;AAIE;EACE,kBAAA;EACA,oBAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,cAAA;EACA,mBAAA;AAFR;AAKM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAMM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAJR;AAOM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AALR;AAOQ;EACE,mBAAA;EACA,2BAAA;AALV;AAQQ;EACE,aAAA;EACA,2CAAA;AANV;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVF;AAYE;EACE,gBAAA;EACA,cAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAXF;AAaE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;AAcI;EACE,2BAAA;AAZN;AAeI;EACE,2BAAA;AAbN;AAiBE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAfN;;AAoBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;AAmBE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAlBN;AAqBI;EACE,cAAA;AAnBN;AAuBE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAtBJ;AAuCI;EACG,sBAAA;EACA,mBAAA;EAID,gBAAA;AAxCN;AA6CI;EACE,gBAAA;EACA,kBAAA;AA3CN;AA6CM;EACE,cAAA;EACA,4FAAA;EACA,oCAAA;AA3CR;AA8CM;EACE,cAAA;EACA,4FAAA;EACA,oCAAA;AA5CR;AAiDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,mBAAA;EACA,2BAAA;AA/CN;AAkDI;EACE,aAAA;EACA,6CAAA;AAhDN;;AAqDA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAlDF;AAoDE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,kBAAA;EACA,cAAA;AAnDJ;AAqDI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAnDN;AAqDM;EACE,gBAAA;EACA,cAAA;AAnDR;AAsDM;EACE,cAAA;EACA,mCAAA;EACA,0BAAA;EACA,kBAAA;EACA,oBAAA;AApDR;;AA0DA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAvDF;AAyDE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAvDJ;AAyDI;EACE,mBAAA;AAvDN;AA2DE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAzDJ;AA2DI;EACE,mBAAA;AAzDN;AA4DI;EACE,mBAAA;EACA,mBAAA;AA1DN;;AAgEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AA7DF;;AAgEA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,gBAAA;AA7DF;AA+DE;EACE,gBAAA;AA7DJ;AAgEE;EACE,gBAAA;AA9DJ;AAiEE;EACE,kCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AA/DJ;AAiEI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/DN;AAkEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhEN;AAkEM;EACE,yBAAA;EACA,cAAA;AAhER;AAmEM;EACE,aAAA;EACA,6CAAA;AAjER;AAsEE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AApEJ;AAuEE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;AArEJ;AAuEI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;AArEN;AAuEM;EACE,mBAAA;AArER;AAyEI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAvEN;AAyEM;EACE,mBAAA;AAvER;AA0EM;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAxER;;AA+EA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AA5EF;AA8EE;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AA5EJ;AA+EE;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA7EJ;AAgFE;EACE,mBAAA;EACA,qBAAA;AA9EJ;AAgFI;EACE,cAAA;AA9EN;AAiFI;EACE,cAAA;AA/EN;;AAqFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAlFF;AAoFE;EACE,cAAA;AAlFJ;;AAuFA;EACE;IACE,aAAA;EApFF;EAuFA;IACE,0BAAA;EArFF;EAwFA;IACE,sBAAA;EAtFF;EAwFE;;IAEE,WAAA;IACA,uBAAA;EAtFJ;EA0FA;IACE,YAAA;IACA,wBAAA;EAxFF;EA2FA;IACE,aAAA;EAzFF;EA4FA;IACE,iBAAA;EA1FF;AACF","sourcesContent":["// EmailConfigSettings.scss - Updated to match InvoiceSettings styling\n.email-config-section {\n  padding: 2rem;\n  background: #f4f6f8;\n  min-height: 100vh;\n  color: #334155;\n  \n  .email-config-title {\n    font-size: 1.4rem;\n    font-weight: 600;\n    color: #004A9A;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n}\n\n.settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.settings-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e0e0e0;\n  \n  .card-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #004A9A;\n    margin-bottom: 1.2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #f1f1f1;\n  }\n\n  &.no-config-card {\n    text-align: center;\n    padding: 3rem 1.5rem;\n\n    .no-config-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 1rem;\n\n      .no-config-icon {\n        color: #9ca3af;\n        margin-bottom: 1rem;\n      }\n\n      h4 {\n        font-size: 1.3rem;\n        font-weight: 600;\n        color: #374151;\n        margin-bottom: 0.5rem;\n      }\n\n      p {\n        font-size: 1rem;\n        color: #6b7280;\n        margin-bottom: 2rem;\n        max-width: 400px;\n      }\n\n      .create-account-btn {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.75rem 1.5rem;\n        background: #004A9A;\n        color: white;\n        border: none;\n        border-radius: 8px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover:not(:disabled) {\n          background: #003a7a;\n          transform: translateY(-1px);\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.2);\n        }\n      }\n    }\n  }\n}\n\n.toggle-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  \n  label {\n    font-weight: 500;\n    color: #475569;\n  }\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  \n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    \n    &:checked + .toggle-slider {\n      background-color: #004A9A;\n    }\n    \n    &:checked + .toggle-slider:before {\n      transform: translateX(24px);\n    }\n    \n    &:focus + .toggle-slider {\n      box-shadow: 0 0 1px #004A9A;\n    }\n  }\n  \n  .toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #c4c4c4;\n    transition: .4s;\n    border-radius: 34px;\n    \n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 22px;\n      width: 22px;\n      left: 2px;\n      bottom: 2px;\n      background-color: white;\n      transition: .4s;\n      border-radius: 50%;\n    }\n  }\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.form-group-email-config {\n  margin-bottom: 1rem;\n  \n  label {\n    display: block;\n    font-weight: 500;\n    color: #475569;\n    margin-bottom: 0.5rem;\n  }\n  \n  input, textarea, select {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    background: #f9fafb;\n    transition: all 0.3s ease;\n    \n    &:focus {\n      outline: none;\n      border-color: #3a86ff;\n      box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\n    }\n    \n    &::placeholder {\n      color: #94a3b8;\n    }\n  }\n  \n  select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.5rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    padding-right: 2.5rem;\n    cursor: pointer;\n  }\n  \n  .display-value {\n    padding: 0.75rem;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    color: #475569;\n    font-size: 0.95rem;\n    margin-bottom: 0.5rem;\n\n    // &.account-type {\n    //   text-transform: capitalize;\n    //   font-weight: 500;\n    //   color: #004A9A;\n    //   background: linear-gradient(135deg, rgba(0, 74, 154, 0.1) 0%, rgba(0, 74, 154, 0.05) 100%);\n    //   border-color: rgba(0, 74, 154, 0.2);\n    // }\n\n    // &.email-address {\n    //   font-family: 'Courier New', monospace;\n    //   color: #059669;\n    //   background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);\n    //   border-color: rgba(5, 150, 105, 0.2);\n    // }\n\n    &.password-mask {\n       font-family: monospace;\n       letter-spacing: 2px;\n      // color: #6b7280;\n      // background: #f1f5f9;\n      // border-color: #cbd5e1;\n      overflow: hidden;\n\n      \n    }\n\n    &.status {\n      font-weight: 600;\n      text-align: center;\n      \n      &.enabled {\n        color: #059669;\n        background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);\n        border-color: rgba(5, 150, 105, 0.2);\n      }\n\n      &.disabled {\n        color: #dc2626;\n        background: linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);\n        border-color: rgba(220, 38, 38, 0.2);\n      }\n    }\n  }\n\n  .change-password-btn {\n    background: #f59e0b;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    margin-top: 0.5rem;\n    \n    &:hover:not(:disabled) {\n      background: #d97706;\n      transform: translateY(-1px);\n    }\n    \n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n    }\n  }\n}\n\n.smtp-info {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #eff6ff;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n\n  .info-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n    color: #3b82f6;\n    font-weight: 500;\n    font-size: 0.875rem;\n  }\n\n  .info-content {\n    font-size: 0.75rem;\n    color: #6b7280;\n\n    .info-item {\n      display: flex;\n      justify-content: space-between;\n      padding: 0.25rem 0;\n\n      .label {\n        font-weight: 500;\n        color: #374151;\n      }\n\n      .value {\n        color: #3b82f6;\n        background: rgba(59, 130, 246, 0.1);\n        padding: 0.125rem 0.375rem;\n        border-radius: 4px;\n        font-size: 0.6875rem;\n      }\n    }\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  \n  .cancel-btn {\n    background: #f1f1f1;\n    color: #475569;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    \n    &:hover {\n      background: #e2e8f0;\n    }\n  }\n  \n  .save-btn {\n    background: #004A9A;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    \n    &:hover:not(:disabled) {\n      background: #003a7a;\n    }\n    \n    &:disabled {\n      background: #c4c4c4;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Modal Styles - Match InvoiceSettings\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 95%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n\n  &.email-config-modal {\n    max-width: 800px;\n  }\n\n  &.password-modal {\n    max-width: 500px;\n  }\n\n  .modal-header {\n    padding: 1.5rem 1.5rem 1rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #e2e8f0;\n\n    h4 {\n      font-size: 1.25rem;\n      font-weight: 600;\n      color: #004A9A;\n      margin: 0;\n    }\n\n    .close-btn {\n      border: none;\n      background: none;\n      cursor: pointer;\n      padding: 0.5rem;\n      border-radius: 6px;\n      color: #6b7280;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        background-color: #f3f4f6;\n        color: #374151;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 1.5rem;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 1rem 1.5rem 1.5rem 1.5rem;\n    border-top: 1px solid #e2e8f0;\n\n    .cancel-btn {\n      background: #f1f1f1;\n      color: #475569;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      padding: 0.75rem 1.25rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s;\n      display: flex;\n      \n      &:hover {\n        background: #e2e8f0;\n      }\n    }\n    \n    .save-btn {\n      background: #004A9A;\n      color: white;\n      border: none;\n      border-radius: 6px;\n      padding: 0.75rem 1.25rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: background-color 0.2s;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      \n      &:hover:not(:disabled) {\n        background: #003a7a;\n      }\n      \n      &:disabled {\n        background: #c4c4c4;\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n    }\n  }\n}\n\n// Step info styles for password change modal\n.step-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  \n  svg {\n    flex-shrink: 0;\n    margin-top: 0.125rem;\n    color: #3b82f6;\n  }\n  \n  p {\n    margin: 0;\n    color: #1e40af;\n    font-size: 0.95rem;\n    line-height: 1.5;\n  }\n  \n  &.success {\n    background: #f0fdf4;\n    border-color: #bbf7d0;\n    \n    svg {\n      color: #16a34a;\n    }\n    \n    p {\n      color: #166534;\n    }\n  }\n}\n\n// Password mismatch error\n.password-mismatch-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  margin-top: 1rem;\n  color: #dc2626;\n  font-size: 0.9rem;\n  \n  svg {\n    flex-shrink: 0;\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .email-config-section {\n    padding: 1rem;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    \n    .cancel-btn,\n    .save-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n\n  .modal {\n    margin: 1rem;\n    width: calc(100% - 2rem);\n  }\n\n  .settings-card {\n    padding: 1rem;\n  }\n  \n  .step-info {\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
